import React from 'react'
import { Article } from '../../../../types/Article'
import cx from 'classnames'
import styles from './ArticlePreview.module.css'
import Link from '../../../../components/Link'

const ArticlePreview: React.FC<{ article: Article | undefined | null }> = ({
    article,
}) => {
    if (!article) {
        return null
    }

    return (
        <div className={'zr-d-flex zr-gap-2 zr-items-center'}>
            <Link url={article.url} target={'_blank'}>
                <img
                    src={article.imgUrl}
                    alt={article.cName}
                    className={cx(styles['article-preview-image'])}
                />
            </Link>
            <Link url={article.url} target={'_blank'}>
                <div
                    className={'zr-d-flex'}
                    style={{ color: 'rgb(45, 45, 45)' }}
                >
                    <div>
                        {article.cArtNr} - {article.cName}
                    </div>
                    <div
                        dangerouslySetInnerHTML={{
                            __html: '(' + article.price[0] + ')',
                        }}
                    ></div>
                </div>
            </Link>
        </div>
    )
}

export default ArticlePreview
